<template>
  <HeadlessRadioGroup>
    <HeadlessRadioGroupLabel v-if="label">
      {{ label }}
    </HeadlessRadioGroupLabel>

    <div
      class="bg-background-fg/5 border-background-fg/6 border-1 flex flex-nowrap items-stretch justify-between space-x-1 rounded-md p-0.5"
    >
      <HeadlessRadioGroupOption
        v-for="option in options"
        :key="option.label"
        as="template"
      >
        <div
          :class="[
            option.value === modelValue
              ? 'bg-background shadow-sm'
              : '',
            'flex-1 cursor-pointer rounded px-1 py-1 text-center text-xs',
          ]"
          @click="emit('update:modelValue', option.value)"
        >
          <HeadlessRadioGroupLabel
            as="span"
            class="line-clamp-1"
          >
            {{ option.label }}
          </HeadlessRadioGroupLabel>
        </div>
      </HeadlessRadioGroupOption>
    </div>
  </HeadlessRadioGroup>
</template>

<script setup lang="ts">
export type ToggleSwitchOption = {
  value: boolean
  label: string
}

defineProps<{
  modelValue?: boolean
  label?: string
  options: ToggleSwitchOption[]
}>()

const emit = defineEmits<{
  (eventName: "update:modelValue", value: boolean): void
}>()
</script>
